import {
    FETCH_CUSTOM_ROUTES,
    FETCH_CUSTOM_ROUTES_SUCCESS,
    FETCH_CUSTOM_ROUTES_FAILED
} from "../store/types";

const INITIAL_STATE = {
    routes: null,
    loading: false,
    error: null,
};

export const customroutesreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_CUSTOM_ROUTES:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_CUSTOM_ROUTES_SUCCESS:
            return {
                ...state,
                routes: action.payload,
                loading: false,
            };
        case FETCH_CUSTOM_ROUTES_FAILED:
            return {
                ...state,
                routes: {},
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
